var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModal
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              showModal: _vm.showModal,
              idProcesso: _vm.idProcesso,
              tipo: _vm.tipoProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModal = false
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "main hidden-xs-only" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: {
                data: _vm.processos,
                "element-loading-text": "Carregando..."
              },
              on: { "sort-change": _vm.changeOrder }
            },
            [
              _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
              _c("el-table-column", {
                attrs: {
                  prop: "numeroProcesso",
                  label: "Processo",
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cpfCnpjInteressado",
                  label: "CPF/CNPJ do interessado",
                  width: "auto",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nomeRazaoSocialInteressado",
                  label: "Nome/ Razão Social do interessado",
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "setor",
                  label: "Setor",
                  formatter: _vm.formatLabelSetor,
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tipo.nome",
                  label: "Tipo de processo",
                  width: "auto"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "small" } },
                              [
                                _vm._v("Ações"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex",
                                      on: {
                                        click: function($event) {
                                          return _vm.abreModal(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-eye" }),
                                      _vm._v("  Visualizar processo")
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("app-paginacao", {
            attrs: {
              total: _vm.totalItems,
              pagina: _vm.currentPage,
              tamanhoPagina: _vm.pageSize
            },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e21d2ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e21d2ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppListagemProcessosAnalisados.vue
// module id = null
// module chunks = 